import React from "react";
import styled from "styled-components";

import IconButton from "../button/IconButton";
import ToolTip from "../tooltip/ToolTip";

/**
 * 説明文をホバーの吹き出しに畳む「？」アイコン。
 *
 * 画面に説明文を常時並べると本題（表やフォーム）が押し下げられて読みにくく
 * なるため、補助的な説明はこのアイコンに集約する。見出しの右や表のツール行の
 * 右端に置く運用を想定している。
 *
 * 本文は `\n` で改行できる（`ToolTip` が改行を保持する）。モバイルでは
 * `ToolTip` 側でホバーが無効化されるため、**操作に必須の情報は入れない**こと。
 */
export interface HelpHintProps {
  /** 吹き出しに出す説明文。`\n` で改行できる。 */
  description: string;
  /** 吹き出しの向き。既定は左（右端に置く前提）。 */
  placement?: "top" | "bottom" | "left" | "right";
  /** アイコンの一辺(px)。既定 18。 */
  size?: number;
  /** スクリーンリーダー向けのラベル。既定は「説明を表示」。 */
  ariaLabel?: string;
}

/** Tippy がホバー / フォーカス対象として受け取れるよう IconButton をラップする */
const Target = styled.span`
  display: inline-flex;
`;

const HelpHint: React.FC<HelpHintProps> = ({
  description,
  placement = "left",
  size = 18,
  ariaLabel = "説明を表示",
}) => {
  if (!description.trim()) return null;

  return (
    <ToolTip description={description} placement={placement}>
      <Target>
        <IconButton icon="help_outline" size={size} ariaLabel={ariaLabel} />
      </Target>
    </ToolTip>
  );
};

export default HelpHint;
